import { Outlet } from "react-router-dom";
import { useCabinetMemberMe } from "@/hooks/useCabinetMemberMe";
import ServerUnavailable from "@/pages/ServerUnavailable";
import { shouldShowServerUnavailable } from "./backendHealth";

/**
 * Layout route (montée sous `ProtectedRoute`) qui prend le contrôle de l'écran
 * avec `<ServerUnavailable/>` quand le backend Hector est injoignable au
 * chargement.
 *
 * Réutilise la requête de bootstrap `useCabinetMemberMe()` : même `queryKey`, donc
 * dédupliquée avec l'appel de `DashboardLayout` → une seule requête réseau.
 * Pendant les retries (`status === 'pending'`) on rend l'app normalement via
 * `<Outlet/>` → pas de flash de la page d'erreur. La décision est isolée dans
 * `shouldShowServerUnavailable` (testée unitairement).
 */
const BackendHealthGate = () => {
  const { status, data, error } = useCabinetMemberMe();

  if (shouldShowServerUnavailable({ status, data, error })) {
    return <ServerUnavailable />;
  }

  return <Outlet />;
};

export default BackendHealthGate;
